import React, { useEffect, useState } from 'react'
import { actions as commonRedux } from 'store/commonRedux/actions'

import { SplashScreen } from 'components'
import { useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

const OnBoardingProvider = (props) => {
  const isOnBoarded = useSelector(({ common }) => common.onboarding)

  const dispatch = useDispatch()

  const [showSplashScreen, setShowSplashScreen] = useState(
    isOnBoarded ? false : true,
  )
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (!isOnBoarded) {
      if (searchParams.get('ignoreOnBoarding')) {
        dispatch(commonRedux.setOnBoarding(true))
        setShowSplashScreen(false)
      } else {
        setShowSplashScreen(false)
      }
    }
  }, [])

  return showSplashScreen ? <SplashScreen /> : <>{props.children}</>
}

export default OnBoardingProvider
